import { Dictionary } from "../types/utils.types";

export const PROBLEM_TYPES: Dictionary<string> = {
  APP: "Full-stack",
  DBA: "Database",
  MCQ: "MCQ",
  SUB: "Subjective",
  MLI: "Machine Learning / AI",
  DSC: "Data Science",
  SEL: "Selenium Testing",
  PRJ: "Project-based",
  FIB: "Fill in the blanks",
  SCR: "Coding",
  UIX: "UI / UX",
  VID: "Video",
  FBE: "File-Based Evaluation",
  WHB: "Whiteboarding",
};

export const PROBLEM_LEVEL: Dictionary<string> = {
  EAS: "Easy",
  MED: "Medium",
  HAR: "Hard",
};

export const USED_PROBLEM_TYPES: Dictionary<string> = {
  SCR: "Coding",
  DBA: "Database",
  SUB: "Subjective",
};

export const EVAL_MODES: Dictionary<string> = {
  ATF: "ATF",
  TXT: "TXT",
};

export const CodingProblemTypes = [
  PROBLEM_TYPES.DBA,
  PROBLEM_TYPES.MLI,
  PROBLEM_TYPES.DSC,
  PROBLEM_TYPES.SEL,
  PROBLEM_TYPES.SCR,
];

export const GET_PROBLEMS_FROM_LIBRARY_API_HTTP_STATUS_CODES = [
  422, 500, 503, 504,
];
export const GET_PROBLEM_DETAIL_API_HTTP_STATUS_CODES = [422, 500, 503, 504];
export const GET_PROBLEMS_FROM_LIBRARY_ERROR_MESSAGE =
  "Error in getting problems from library";
export const GET_PROBLEM_DETAIL_ERROR_MESSAGE =
  "Error in getting problem details";
